<template>
  <ModalConfirmation
    hasBlur
    :primaryButtonProps="$options.primaryButtonProps"
    :showModal="showModal"
    :title="modalConfig.title"
    @cancel="handleCancel"
    @close="handleClose"
    @save="handleSave"
  >
    <template v-slot:body>
      <div>
        <ParagraphBody
          v-for="text in modalConfig.bodyText"
          :key="text"
        >
          {{ text }}
        </ParagraphBody>
        <Button
          hasNoBackground
          isExternal
          text="Learn More"
          type="informational"
          @click="handleKbLinkClick"
        />
      </div>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  Button, ModalConfirmation, ParagraphBody, Types,
} from '@jumpcloud/ui-components';
import { events } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventManager from 'client/GrowthEngineering/EventManager';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import Util from 'client/util/Util';

const { openUrl } = Util;
const { triggerEvent } = EventManager;
const { PrimaryButtonProps } = Types;
const primaryButtonProps = PrimaryButtonProps({
  text: 'continue',
});

export default {
  name: 'ModalSystemInsights',

  components: {
    Button,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    enableSystemInsights: Boolean,
    showModal: Boolean,
  },

  computed: {
    modalConfig() {
      let modalContent = {
        bodyText: ['Disabling will remove the System Insights data collection for all devices in your organization. Are you sure?'],
        title: 'Disable System Insights',
      };

      if (this.enableSystemInsights) {
        modalContent = {
          bodyText: ['Try free for a limited time.', 'System Insights provides fleet-wide inventory, security, and configuration intelligence. Take it for a spin and we will contact you soon to see how it’s going.'],
          title: 'Enable System Insights',
        };
      }

      return modalContent;
    },
  },

  openUrl,
  primaryButtonProps,
  triggerEvent,

  methods: {
    handleCancel() {
      this.$emit('cancel');
    },

    handleClose() {
      this.$emit('close');
    },

    handleKbLinkClick() {
      this.$options.openUrl(KbArticleUrls.systemInsights);
      this.$options.triggerEvent(events.enableSystemInsightsKbLinkClicked);
    },

    handleSave() {
      this.$emit('save');
    },
  },
};
</script>
